import axios from 'axios';

// Ported from grant_management. Same-origin (`/api`): callbox resolves the tenant
// from the subdomain and injects X-TENANT before Django sees the request, so the
// browser must never point these at another origin — that would drop the header.
const apiClient = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // include the session cookie for SessionAuthentication
});

apiClient.interceptors.request.use((config) => {
  // DRF TokenAuthentication: the token the magic-link verify returned.
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Token ${token}`;
  }
  // CSRF for session-authenticated unsafe methods.
  const csrfToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrftoken='))
    ?.split('=')[1];
  if (csrfToken) {
    config.headers['X-CSRFToken'] = csrfToken;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only bounce to login if the user HAD a token (an expired session).
      // Anonymous callers — the public donate/map pages — must handle their own
      // 401s and must not be redirected.
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
